const map = {
	"./10/10c.png": 6832,
	"./10/10d.png": 8159,
	"./10/10h.png": 5171,
	"./10/10s.png": 6416,
	"./2/2c.png": 364,
	"./2/2d.png": 531,
	"./2/2h.png": 3871,
	"./2/2s.png": 9756,
	"./3/3c.png": 6484,
	"./3/3d.png": 1291,
	"./3/3h.png": 7959,
	"./3/3s.png": 1332,
	"./4/4c.png": 816,
	"./4/4d.png": 5791,
	"./4/4h.png": 9155,
	"./4/4s.png": 4048,
	"./5/5c.png": 2040,
	"./5/5d.png": 4679,
	"./5/5h.png": 2411,
	"./5/5s.png": 488,
	"./6/6c.png": 1556,
	"./6/6d.png": 3819,
	"./6/6h.png": 4503,
	"./6/6s.png": 3156,
	"./7/7c.png": 7052,
	"./7/7d.png": 7219,
	"./7/7h.png": 4207,
	"./7/7s.png": 268,
	"./8/8c.png": 3088,
	"./8/8d.png": 5311,
	"./8/8h.png": 6115,
	"./8/8s.png": 352,
	"./9/9c.png": 8888,
	"./9/9d.png": 4055,
	"./9/9h.png": 3371,
	"./9/9s.png": 1448,
	"./A/Ac.png": 4440,
	"./A/Ad.png": 6436,
	"./A/Ah.png": 5627,
	"./A/As.png": 7000,
	"./J/Jc.png": 9852,
	"./J/Jd.png": 3459,
	"./J/Jh.png": 623,
	"./J/Js.png": 4108,
	"./K/Kc.png": 8660,
	"./K/Kd.png": 2523,
	"./K/Kh.png": 5287,
	"./K/Ks.png": 7684,
	"./Q/Qc.png": 4248,
	"./Q/Qd.png": 6391,
	"./Q/Qh.png": 3851,
	"./Q/Qs.png": 1928,
	"./Reverse/Reverse1.webp": 2547,
	"./_extras/ace_of_spades2.png": 8703,
	"./_extras/black_joker.png": 8532,
	"./_extras/jack_of_clubs2.png": 7876,
	"./_extras/jack_of_diamonds2.png": 6972,
	"./_extras/jack_of_hearts2.png": 4596,
	"./_extras/jack_of_spades2.png": 567,
	"./_extras/king_of_clubs2.png": 24,
	"./_extras/king_of_diamonds2.png": 7312,
	"./_extras/king_of_hearts2.png": 9200,
	"./_extras/king_of_spades2.png": 2835,
	"./_extras/queen_of_clubs2.png": 8563,
	"./_extras/queen_of_diamonds2.png": 8877,
	"./_extras/queen_of_hearts2.png": 7969,
	"./_extras/queen_of_spades2.png": 9050,
	"./_extras/red_joker.png": 9856
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7278;